import { useEffect, useState } from "react";
import { PaginationRequest, PaginationResult } from "../../../api/Common/Util";
import InventoryItemsService from "../../../api/Inventory/InventoryItemsService";
import useLoading from "../../../components/Common/useLoading";

const propsTemplate = () => ({ ...new PaginationRequest(), search: '', includeStock: false, includeLastEntry: false });

export default function usePharmacyItems({ preload = false, requestProps = propsTemplate() } = {}) {
    const [pagedItems, setPagedItems] = useState(new PaginationResult());
    const [isLoading, doLoad, reload] = useLoading({
        onLoad: async () => {
            if (!preload) return;
            await FindItems({ ...requestProps });
        },
        onError: (error) => setPagedItems(new PaginationResult())
    });

    const Navigation = {
        ToPage: async ({ page }) => doLoad(async () => {
            const request = pagedItems.ToPage(page);

            if (request == null) return;
            await FindItems({ ...requestProps, ...request });
        }),
        Find: async (props = propsTemplate()) => doLoad(async () => {
            const newRequest = { ...requestProps, ...props };
            await FindItems(newRequest);
        }),
        Clear: () => setPagedItems(new PaginationResult()),
        Reload: reload
    };

    async function FindItems(props) {
        const result = await InventoryItemsService.FindLaboratoryKitInventory({ ...props });
        result.SortColumn = requestProps.sortColumn
        result.SortOrder = requestProps.sortOrder

        setPagedItems(result);
    }

    return [pagedItems, isLoading, Navigation];
}
